import classnames from 'classnames/bind'
import React from 'react'

import Image, { ImageProps } from '~/components/Image'
import ImageWithPlaceholder from '~/components/ImageWithPlaceholder'
import Link, { LinkProps } from '~/components/Link'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ClientProps {
  className?: string
  name?: string
  image?: ImageProps
  imageBlue?: ImageProps
  link?: LinkProps
  responsive?: boolean
  color?: 'normal' | 'blue'
  objectPosition?: string
}
/**
 * Client component
 * @param props
 * @returns Component
 */
function Client({
  className,
  image,
  imageBlue,
  name,
  link,
  color = 'normal',
  objectPosition = '50% 50%',
}: ClientProps) {
  const content =
    color === 'normal'
      ? image && (
          <ImageWithPlaceholder
            className={cx(css.image)}
            {...{ layout: 'fill', objectFit: 'contain', objectPosition }}
            {...image}
          />
        )
      : imageBlue && (
          <ImageWithPlaceholder
            className={cx(css.image)}
            {...{ layout: 'fill', objectFit: 'contain', objectPosition }}
            {...imageBlue}
          />
        )

  return (
    <div className={cx(css.Client, className)}>
      {link && name ? (
        <Link className={css.client} title={name} {...link}>
          {content}
        </Link>
      ) : (
        <div className={css.client}>{content}</div>
      )}
    </div>
  )
}

Client.defaultProps = {}

export default Client
